<ion-app>
  <app-advertizing-impression
    #advertizingImpression
    [isVisible]="displayingImpression"
    [advertizementImage]="advertizementImage"
    [advertizementDescription]="advertizementDescription"
    [advertizementURL]="advertizementURL"
    [advertizementURLText]="advertizementURLText"
    [advertizementRemainingTime]="advertizementRemainingTime"
    [advertizementMinTime]="advertizementMinTime"
    [advertizementCfgImpressId]="advertizementCfgImpressId"
    [advertizementImpressLogId]="advertizementImpressLogId"
    [agentId]="agentId"
  >
  </app-advertizing-impression>

  <app-advertizing-prize
    #advertizingPrize
    [isVisible]="displayingPrize"
    [prizeImage]="prizeImage"
    [prizeDescription]="prizeDescription"
    [prizeURL]="prizeURL"
    [prizeURLText]="prizeURLText"
    [advertizementCfgPrizeId]="advertizementCfgPrizeId"
    [advertizementPrizeLogId]="advertizementPrizeLogId"
    [agentId]="agentId"
  >
  </app-advertizing-prize>

  <app-connectivity-overlay
    [underSplash]="splashScreen && !platform.is('mobile')"
  ></app-connectivity-overlay>

  <div
    *ngIf="splashScreen && !platform.is('mobile')"
    class="splash"
    [ngClass]="{ 'splash-faded': splashFaded }"
  >
    <div #lottieSpash></div>
  </div>
  <div class="app-shell">
    <app-side-nav
      [pages]="appPages"
      [selectedIndex]="selectedIndex"
      [userAvatar]="userAvatar"
      [userDisplayName]="userDisplayName"
      [isAnonymous]="isAnonymous"
      (navigate)="onSideNavNavigate($event)"
      (profileClick)="onSideNavProfile()"
      (loginClick)="logout(true)"
    ></app-side-nav>
    <ion-router-outlet id="main-content" class="app-shell__main"></ion-router-outlet>
  </div>
  <app-confirm-popup></app-confirm-popup>
  <app-toast></app-toast>

  <!-- News popup – shown once on app open when unseen GENERIC news exists -->
  <app-news-popup
    [open]="showNewsPopup"
    [payload]="newsPayload$ | async"
    (closed)="onNewsPopupClosed()"
  >
  </app-news-popup>

  <!-- Sticker detail overlay – full-screen, app-wide, above header/navbar -->
  <ng-container *ngIf="stickerOverlayState$ | async as overlayState">
    <app-v2-detail-overlay
      [isOpen]="overlayState.isOpen"
      [items]="overlayState.items"
      [sections]="overlayState.sections"
      [currentSectionIndex]="overlayState.currentSectionIndex"
      [selectedIndex]="overlayState.selectedIndex"
      [collectionDetails]="overlayState.collectionDetails"
      [iconLocationPrefix]="overlayState.iconLocationPrefix ?? ''"
      [viewMode]="overlayState.viewMode ?? 'slideView'"
      [showVideo]="overlayState.showVideo ?? true"
      [showFooter]="overlayState.showFooter ?? true"
      [isMobile]="overlayState.isMobile ?? false"
      [iconColor]="overlayState.iconColor ?? ''"
      [videoSrc]="overlayState.videoSrc ?? ''"
      [aspectRatio]="overlayState.aspectRatio ?? 'PORTRAIT'"
      [hasVideoLoaded]="overlayState.hasVideoLoaded ?? false"
      [showOpenAlbumButton]="overlayState.showOpenAlbumButton ?? false"
      (closed)="onStickerOverlayClosed()"
      (itemChange)="onStickerOverlayItemChange($event)"
      (playVideo)="onStickerOverlayPlayVideo($event)"
      (sectionChangeRequest)="onStickerOverlaySectionChange($event)"
      (videoEnded)="onStickerOverlayVideoEnded()"
      (footerAction)="onStickerOverlayFooterAction($event)"
      (videoLoadState)="onStickerOverlayVideoLoadState($event)"
      (videoBack)="onStickerOverlayVideoBack()"
      (openAlbum)="onStickerOverlayOpenAlbum($event)"
    >
    </app-v2-detail-overlay>
  </ng-container>

  <!-- Trade request detail – full-screen overlay -->
  <ng-container *ngIf="tradeRequestDetailOverlayState$ | async as trdState">
    <app-v2-trade-request-detail-overlay
      [isOpen]="trdState.isOpen"
      [request]="trdState.request"
      [collectionType]="trdState.collectionType"
      [collectionId]="trdState.collectionId"
      [agentId]="trdState.agentId"
      [userCollectionDetails]="trdState.userCollectionDetails"
      [readOnly]="trdState.readOnly"
      [listNav]="trdState.listNav"
      (closed)="onTradeRequestDetailOverlayClosed()"
      (actionRequested)="onTradeRequestDetailAction($event)"
    ></app-v2-trade-request-detail-overlay>
  </ng-container>

  <!-- Open binders – full-screen overlay (manage style) -->
  <ng-container *ngIf="openBindersState$ | async as obState">
    <app-v2-open-binders
      [isOpen]="obState.isOpen"
      [agentId]="obState.agentId"
      [collectionId]="obState.collectionId"
      [userCollectionId]="obState.userCollectionId"
      (closed)="onOpenBindersClosed($event)"
    >
    </app-v2-open-binders>
  </ng-container>

  <!-- Open spinners – full-screen overlay (manage style) -->
  <ng-container *ngIf="openSpinnersState$ | async as osState">
    <app-v2-open-spinners
      [isOpen]="osState.isOpen"
      [agentId]="osState.agentId"
      [collectionId]="osState.collectionId"
      [userCollectionId]="osState.userCollectionId"
      (presentV3Cards)="onOpenSpinnersPresentV3Cards($event)"
      (closed)="onOpenSpinnersClosed($event)"
    >
    </app-v2-open-spinners>
  </ng-container>

  <!-- Get binders – full-screen overlay (manage style) -->
  <ng-container *ngIf="getBindersState$ | async as gbState">
    <app-v2-get-binders
      [isOpen]="gbState.isOpen"
      [agentId]="gbState.agentId"
      [collectionId]="gbState.collectionId"
      [userCollectionId]="gbState.userCollectionId"
      [giftInfoOnly]="gbState.giftInfoOnly"
      (closed)="onGetBindersClosed($event)"
    >
    </app-v2-get-binders>
  </ng-container>

  <!-- Add multiple items – full-screen overlay (manage style) -->
  <ng-container *ngIf="addMultipleItemsState$ | async as amState">
    <app-v2-add-multiple-items
      [isOpen]="amState.isOpen"
      [itemsList]="amState.itemsList"
      (closed)="onAddMultipleItemsClosed($event)"
    >
    </app-v2-add-multiple-items>
  </ng-container>

  <!-- Album view – full-screen overlay -->
  <ng-container *ngIf="albumOverlayState$ | async as aoState">
    <app-v2-album-overlay
      [isOpen]="aoState.isOpen"
      [albumPagesSorted]="aoState.albumPagesSorted"
      [albumSections]="aoState.albumSections"
      [tradesEnabled]="aoState.tradesEnabled"
      [stickerUrlPrefix]="aoState.stickerUrlPrefix ?? ''"
      [iconLocationPrefix]="aoState.iconLocationPrefix"
      [noStickerImgP]="aoState.noStickerImgP"
      [noStickerImgL]="aoState.noStickerImgL"
      [ownedItemIds]="aoState.ownedItemIds"
      [fullItemList]="aoState.fullItemList"
      [focusItemId]="aoState.focusItemId"
      [initialPageIndex]="aoState.initialPageIndex ?? 0"
      [showBuyAlbumButton]="aoState.showBuyAlbumButton ?? false"
      [collectionComplete]="aoState.collectionComplete ?? false"
      (closed)="onAlbumOverlayClosed($event)"
    ></app-v2-album-overlay>
  </ng-container>

  <!-- Order physical album – full-screen overlay (v2) -->
  <ng-container *ngIf="requestPhysicalCollectionOverlayState$ | async as rpcState">
    <app-v2-request-physical-collection
      [isOpen]="rpcState.isOpen"
      [agentId]="rpcState.agentId"
      [collectionId]="rpcState.collectionId"
      [userCollectionId]="rpcState.userCollectionId"
      [maxNumAlbumPerUser]="rpcState.maxNumAlbumPerUser"
      (closed)="onRequestPhysicalCollectionOverlayClosed($event)"
    ></app-v2-request-physical-collection>
  </ng-container>

  <!-- Dev theme toggle (development only) -->
  <button
    *ngIf="showDevThemeToggle"
    class="dev-theme-toggle"
    (click)="toggleDevTheme()"
    title="Toggle theme (dev)"
  >
    <ion-icon
      [name]="devThemeIsDark ? 'sunny-outline' : 'moon-outline'"
    ></ion-icon>
    {{ devThemeIsDark ? "Light" : "Dark" }}
  </button>

</ion-app>
